import { useEffect, useState } from 'react';
import ITestRepository from '../../2_domain/test/iTestRepository';
import { TestItemSummary } from '../../2_domain/test/test';
import Get from '../../lib/di/get';
import promiseResolver from '../../lib/util/promiseResolver';

let timer: NodeJS.Timeout | undefined;

const useTestAddTestItemSelectListController = (
  testItems: TestItemSummary[],
  addTestItem: (testItem: TestItemSummary) => void,
  removeTestItem: (testItem: TestItemSummary) => void
) => {
  const testRepo = Get.find<ITestRepository>('ITestRepository');

  const [searchText, setSearchText] = useState('');
  const [baseTestItems, setBaseTestItems] = useState<TestItemSummary[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<Category>();

  const onReset = () => {
    setSearchText('');
    setSelectedCategory(undefined);
  };

  const isSelected = (testItem: TestItemSummary) => {
    const filtered = testItems.filter((item) => item.id === testItem.id);
    return filtered.length !== 0;
  };

  const toggleItem = (testItem: TestItemSummary) => {
    if (isSelected(testItem)) {
      removeTestItem(testItem);
    } else {
      addTestItem(testItem);
    }
  };

  const loadBaseItems = () => {
    promiseResolver({
      promise: testRepo.getTestItemSummaries(
        searchText,
        selectedCategory ?? 'TEST_ALL'
      ),
      successCallback: (data) => {
        setBaseTestItems(data);
      },
      isLoadingCallback: setIsLoading,
    });
  };

  useEffect(() => {
    setIsLoading(true);
    clearTimeout(timer);
    timer = setTimeout(loadBaseItems, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  useEffect(() => {
    loadBaseItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategory]);

  return {
    searchText,
    setSearchText,
    baseTestItems,
    isLoading,
    selectedCategory,
    setSelectedCategory,
    onReset,
    toggleItem,
    isSelected,
  };
};

export default useTestAddTestItemSelectListController;
